import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export const initFmbSlider = (): void => {
  const sliderElements = document.querySelectorAll<HTMLElement>(
    "[data-fmb-slider] .swiper",
  );

  if (sliderElements.length === 0) {
    return;
  }

  sliderElements.forEach((sliderEl) => {
    new Swiper(sliderEl, {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".fmb-slider__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".fmb-slider__nav-next",
        prevEl: ".fmb-slider__nav-prev",
      },
    });
  });

  console.log("[Slider] FMB Hero Slider initialized.");
};
